import { render, staticRenderFns } from "./Pond.vue?vue&type=template&id=98b45e5c&scoped=true&"
import script from "./Pond.vue?vue&type=script&lang=js&"
export * from "./Pond.vue?vue&type=script&lang=js&"
import style0 from "./Pond.vue?vue&type=style&index=0&id=98b45e5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b45e5c",
  null
  
)

export default component.exports